import React, { useEffect, useMemo } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import { handleDetailRPDFilterParamsToApi } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import RPDContext from './index';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  getStatsRPDValidUrlParams,
  getCountriesRPDValidUrlParams,
  statsRPDValidCfg,
  countriesRPDValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import { useShortLink } from '@intelligence/hooks/useShortLink';
import { useIntl } from 'umi';

export default function RPDComp(props: any) {
  const { urlFilterValue, tabType, entityType } = props;

  const { formatMessage } = useIntl();
  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.rpd,
  });

  const isCoutriesPage = tabType === 'countries';
  const currentValidCfg = isCoutriesPage ? countriesRPDValidCfg : statsRPDValidCfg;
  const getValidUrlParams = isCoutriesPage
    ? getCountriesRPDValidUrlParams
    : getStatsRPDValidUrlParams;
  // 是否有短链接更新功能
  const hasUrlShortLink = isCoutriesPage
    ? hasShortLinkRatio.detailMobileCountriesRPD
    : hasShortLinkRatio.detailMobileStatsRPD;
  const {
    initShortLinkCfgNoAwait,
    shortLinkLoading,
    urlCustomParams,
    shortLinkFilterValue,
    shortLinkValidQuery,
  } = useShortLink({
    urlFilterValue,
    hasUrlShortLink,
    getPageValidCfg: () => currentValidCfg,
    getCustomValidUrlParams: getValidUrlParams,
  });

  useEffect(() => {
    // 进入页面时判断是否有tokenQuery等，有则进入
    initShortLinkCfgNoAwait();
  }, []);

  const defaultFilterValue = useMemo(
    () => ({
      [filterKeyMap.REGION]: {
        regions: [],
        markets: ['global'],
        type: 'market',
      },
      [filterKeyMap.RANGE_TIME]: {
        type: 'month',
        value: ['', ''],
      },
      [filterKeyMap.PLATFORM]: { value: ['appstore', 'googleplay'] },
      [filterKeyMap.DATASOURCESIM]: {
        value: 'sensortower',
      },
    }),
    [],
  );

  const filterCfg: TopchartFilterCfgType = useMemo(
    () => ({
      filterKeyList: [
        filterKeyMap.RANGE_TIME,
        filterKeyMap.REGION,
        filterKeyMap.PLATFORM,
        filterKeyMap.DATASOURCESIM,
      ],
      regionFilterParams: {},
      defaultValue: defaultFilterValue,
      resetFilterValue: {
        ...defaultFilterValue,
      },
      specialParams: {
        regionOptions, // 国家筛选器options,
        defalutMarket: ['global'], // 没取到交集用的默认值
        disableNoChina: false,
        rangeTimeType: FilterTimeType.commonRange,
        isShowAlloftime: false,
        globalInfo: formatMessage({ id: `dbi_info_global_filter2` }),
        showShortcut: true,
        entityType,
      },
      showConfirmButton: false,
      haveFilterSaveBtn: false,
      handleFilterToApiParams: handleDetailRPDFilterParamsToApi,
      hasUrlShortLink,
    }),
    [hasUrlShortLink, defaultFilterValue, regionOptions],
  );

  return (
    <RPDContext
      {...props}
      isCoutriesPage={isCoutriesPage}
      filterLoading={filterLoading || shortLinkLoading}
      // 筛选器相关配置如筛选器展示顺序，默认值等
      filterCfg={filterCfg}
      // 从短链接中拿到校正后的url参数（与页面相关）
      urlCustomParams={urlCustomParams}
      // 筛选器有效的页面配置值
      shortLinkValidQuery={shortLinkValidQuery}
      // 从短链接拿到的筛选器分享值
      shortLinkFilterValue={shortLinkFilterValue}
    />
  );
}
